import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRTL } from '../i18n';

/**
 * RTLWrapper - Composant qui gère automatiquement la direction RTL/LTR
 * Enveloppe l'application pour appliquer les styles RTL quand nécessaire
 */
export function RTLWrapper({ children }) {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    const updateDirection = () => {
      const dir = isRTL(i18n.language) ? 'rtl' : 'ltr';
      document.documentElement.dir = dir;
      document.documentElement.lang = i18n.language;
      
      // Classes CSS pour le styling conditionnel
      if (dir === 'rtl') {
        document.documentElement.classList.add('rtl');
        document.documentElement.classList.remove('ltr');
        document.body.style.fontFamily = "'Heebo', 'Inter', sans-serif";
      } else {
        document.documentElement.classList.add('ltr');
        document.documentElement.classList.remove('rtl');
        document.body.style.fontFamily = "'Inter', sans-serif";
      }
    };
    
    updateDirection();
    
    // Écouter les changements de langue
    i18n.on('languageChanged', updateDirection);
    
    return () => {
      i18n.off('languageChanged', updateDirection);
    };
  }, [i18n]);
  
  return children;
}

export default RTLWrapper;
